module.exports = "<p>\n  functional-menu works!\n</p>\n"